import Tools from '../views/Tools';
import ToolsIndex from '../views/tools/Index';
import ToolsDebtSnowball from '../views/tools/DebtSnowball';
import ToolsTruthCalculator from '../views/tools/TruthCalculator';
import ToolsWealthEnhancer from '../views/tools/WealthEnhancer';

export const TOOLS_ROUTES = {
  path: '/tools',
  component: Tools,
  meta: { title: 'Tools' },
  children: [
    {
      path: '',
      name: 'tools',
      component: ToolsIndex,
      meta: { title: 'Tools' }
    },
    {
      path: 'debt-snowball',
      name: 'tools-debt-snowball',
      component: ToolsDebtSnowball,
      meta: { title: 'Debt Snowball Calculator' }
    },
    {
      path: 'truth-calculator',
      name: 'tools-truth-calculator',
      component: ToolsTruthCalculator,
      meta: { title: 'Truth Calculator', background: 'grey lighten-5' }
    },
    {
      path: 'wealth-enhancer',
      name: 'tools-wealth-enhancer',
      component: ToolsWealthEnhancer,
      meta: { title: 'Wealth Enhancer' }
    }
  ]
};
